export function renderLikeButton(
	button: HTMLAnchorElement | HTMLButtonElement,
	photoId: number,
	isLiked: boolean,
	totalLikes: number,
) {
	button.dataset.photoId = photoId.toString();

	const activeClassName = "is-active";
	const hiddenClassName = "is-hidden";

	if (!isLiked) {
		button.classList.remove(activeClassName);
	} else {
		button.classList.add(activeClassName);
	}

	const totalLikesEl = button.querySelector(".total-likes");

	if (totalLikesEl) {
		if (totalLikes > 0) {
			totalLikesEl.classList.remove(hiddenClassName);
		} else {
			totalLikesEl.classList.add(hiddenClassName);
		}

		totalLikesEl.textContent = totalLikes.toString();
	}

	const textLabel = button.querySelector(".button-text");

	if (textLabel) {
		textLabel.innerHTML = totalLikes > 1 ? "Likes" : "Like";
	}
}
